import "./../../../assets/css/GlobalTabbedContentView/GlobalTabsSwitcherContent.scss";
import PharmacyName from "./../../PharmacyName/PharmacyName";
import { Tabs, Tab } from "@mui/material";
import TeamMembers from "../../Header/TeamMembers";
import useTitanApp from "../../../hooks/useTitanApp";
import { FiCheck, FiUsers } from "react-icons/fi";
import { useNavigate } from "react-router";
import {
  setCurrentGlobalTabValue,
  setPatientInfoTab,
} from "../../../dispatchers/appDispatchers";
import { Cpu, FileText, Heart } from "lucide-react";
import { BarChart3, Briefcase } from "lucide-react";
import { checkUserPermissions } from "../../../utils/checkUserPermissions";
import {
  accessTitanversePatientView,
  accessTitanverseApprovalView,
  accessTitanverseCalenderUpsert,
  accessTitanverseCalenderView,
  accessTitanversePrescriptionApproval,
  accessTitanverseAnalyticsView,
  accessTitanversUserUpsert,
} from "../../../data/constantStrings";
export default function GlobalTabsSwitcher({
  handleGlobalTabsChange,
  stopTranscription,
}) {
  const overviewIcon = (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.6401 6.96504C13.3921 6.96504 14.0017 7.57464 14.0017 8.32661V13.3838C14.0017 14.1358 13.3921 14.7454 12.6401 14.7454H9.13898C8.38701 14.7454 7.77742 14.1358 7.77742 13.3838V8.32661C7.77742 7.57464 8.38701 6.96504 9.13898 6.96504H12.6401ZM4.87394 10.0869C5.62591 10.0869 6.2355 10.6964 6.2355 11.4484V13.3838C6.2355 14.1358 5.62591 14.7454 4.87394 14.7454H1.36156C0.609593 14.7454 0 14.1358 0 13.3838V11.4484C0 10.6964 0.609593 10.0869 1.36156 10.0869H4.87394ZM12.6401 8.1321H9.13898C9.03156 8.1321 8.94447 8.21918 8.94447 8.32661V13.3838C8.94447 13.4913 9.03156 13.5784 9.13898 13.5784H12.6401C12.7476 13.5784 12.8347 13.4913 12.8347 13.3838V8.32661C12.8347 8.21918 12.7476 8.1321 12.6401 8.1321ZM4.87394 11.2539H1.36156C1.25414 11.2539 1.16705 11.341 1.16705 11.4484V13.3838C1.16705 13.4913 1.25414 13.5784 1.36156 13.5784H4.87394C4.98136 13.5784 5.06845 13.4913 5.06845 13.3838V11.4484C5.06845 11.341 4.98136 11.2539 4.87394 11.2539ZM4.86273 0.739441C5.6147 0.739441 6.22429 1.34903 6.22429 2.101V7.15824C6.22429 7.87261 5.67413 8.45849 4.9744 8.51529L4.86273 8.51981H1.36156C0.609593 8.51981 0 7.91021 0 7.15824V2.101C0 1.34903 0.609593 0.739441 1.36156 0.739441H4.86273ZM4.86273 1.9065H1.36156C1.25414 1.9065 1.16705 1.99358 1.16705 2.101V7.15824C1.16705 7.26567 1.25414 7.35275 1.36156 7.35275H4.86273L4.90733 7.34761C4.99326 7.32746 5.05724 7.25032 5.05724 7.15824V2.101C5.05724 1.99358 4.97015 1.9065 4.86273 1.9065ZM12.6401 0.739441C13.3921 0.739441 14.0017 1.34903 14.0017 2.101V4.0461C14.0017 4.79807 13.3921 5.40766 12.6401 5.40766H9.13898C8.38701 5.40766 7.77742 4.79807 7.77742 4.0461V2.101C7.77742 1.34903 8.38701 0.739441 9.13898 0.739441H12.6401ZM9.13898 1.9065C9.03156 1.9065 8.94447 1.99358 8.94447 2.101V4.0461C8.94447 4.15352 9.03156 4.24061 9.13898 4.24061H12.6401C12.7476 4.24061 12.8347 4.15352 12.8347 4.0461V2.101C12.8347 1.99358 12.7476 1.9065 12.6401 1.9065H9.13898Z"
        className="icons-color"
      />
    </svg>
  );

  const servicesIcon = (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="icons-color"
    >
      <path d="M14.4043 -0.0119098C14.3879 -0.00894106 14.3716 -0.00448795 14.3568 -3.48054e-05C14.2143 0.0251996 14.1 0.129106 14.0599 0.267153C14.0198 0.406684 14.0614 0.555122 14.1668 0.65309L14.6536 1.13997L11.7799 4.01372L11.3761 3.62184C11.3568 3.58622 11.3331 3.55504 11.3049 3.52684L11.2455 3.47934C11.2336 3.47043 11.2218 3.46301 11.2099 3.45559L10.153 2.38684C10.0743 2.30223 9.96004 2.25918 9.84426 2.26809C9.82793 2.27106 9.8116 2.27551 9.79676 2.27997C9.65426 2.3052 9.53996 2.40911 9.49988 2.54715C9.4598 2.68668 9.50137 2.83512 9.60676 2.93309L10.4736 3.79997L2.38676 11.8868C2.29176 11.9833 2.25465 12.1243 2.29176 12.255L2.95676 14.9031L0.379883 17.48V19L3.71676 15.6631L6.36488 16.3281C6.49551 16.3652 6.63652 16.3281 6.73301 16.2331L14.8199 8.14622L15.6868 9.01309C15.8382 9.1645 16.0816 9.1645 16.233 9.01309C16.3844 8.86168 16.3844 8.61825 16.233 8.46684L15.1405 7.37434C15.1093 7.33129 15.0678 7.29418 15.0218 7.26747L14.6061 6.83996L17.4799 3.96622L17.9668 4.45309C18.1182 4.6045 18.3616 4.6045 18.513 4.45309C18.6644 4.30168 18.6644 4.05825 18.513 3.90684L14.713 0.10684C14.6343 0.0222308 14.52 -0.0208161 14.4043 -0.0119098ZM15.1999 1.68622L16.9336 3.41997L14.0599 6.29372L12.3261 4.55997L15.1999 1.68622ZM11.0199 4.34622L14.2736 7.59997L6.34113 15.5325L3.72863 14.8912L3.08738 12.2787L3.60988 11.7562C3.62176 11.7651 3.63363 11.7725 3.64551 11.78L5.04676 13.1931C5.19816 13.3445 5.4416 13.3445 5.59301 13.1931C5.74441 13.0417 5.74441 12.7982 5.59301 12.6468L4.17988 11.2456C4.17246 11.2367 4.16504 11.2293 4.15613 11.2218L5.12988 10.2362C5.13434 10.2362 5.1373 10.2362 5.14176 10.2362C5.14918 10.2451 5.1566 10.2525 5.16551 10.26L5.80676 10.9131C5.95816 11.0645 6.2016 11.0645 6.35301 10.9131C6.50441 10.7617 6.50441 10.5182 6.35301 10.3668L5.69988 9.72559C5.69246 9.71668 5.68504 9.70926 5.67613 9.70184L6.66176 8.71622C6.66918 8.72512 6.6766 8.73254 6.68551 8.73997L8.08676 10.1531C8.23816 10.3045 8.4816 10.3045 8.63301 10.1531C8.78441 10.0017 8.78441 9.75825 8.63301 9.60684L7.21988 8.20559C7.21246 8.19668 7.20504 8.18926 7.19613 8.18184L8.18176 7.19622C8.18918 7.20512 8.1966 7.21254 8.20551 7.21996L8.84676 7.87309C8.99816 8.0245 9.2416 8.0245 9.39301 7.87309C9.54441 7.72168 9.54441 7.47825 9.39301 7.32684L8.73988 6.68559C8.73246 6.67668 8.72504 6.66926 8.71613 6.66184L9.70176 5.67622C9.70918 5.68512 9.7166 5.69254 9.72551 5.69997L11.1268 7.11309C11.2782 7.2645 11.5216 7.2645 11.673 7.11309C11.8244 6.96168 11.8244 6.71825 11.673 6.56684L10.2599 5.16559C10.2525 5.15668 10.245 5.14926 10.2361 5.14184L11.0199 4.34622Z" />
    </svg>
  );
  const { appState } = useTitanApp();
  const {
    isAppLoading,
    isTabLoading,
    features,
    headerTeamMembers,
    globalTab,
    darkMode,
    currentPharmacy,
  } = appState || {};
  const {
    ifClinicalChecksEnabled,
    ifWorkForceTabEnabled,
    ifScheduleTabEnabled,
    ifKanbanSearchBoxEnabled,
    ifPharmacyDashboardEnabled,
    ifDocumentsEnabled,
    NewPatientDashboard,
    ifPharmacyAnalyticsEnabled,
    ifHeadOfficeEnabled,
    ifNewCalendar,
  } = features;
  const navigate = useNavigate();
  const handlePatientTabClick = (e) => {
    e.stopPropagation();
    setPatientInfoTab(2);
    navigate(`/pharmacy/patientlist/${currentPharmacy?.teamPharmacyID}`);
  };
  const handleApprovalTabClick = () => {
    setPatientInfoTab(3);
  };
  const handleDocumentClick = () => {};

  const canViewPatients = checkUserPermissions(accessTitanversePatientView);
  const canViewApprovals = checkUserPermissions(accessTitanverseApprovalView);
  const canViewCalendar =
    checkUserPermissions(accessTitanverseCalenderView) ||
    checkUserPermissions(accessTitanverseCalenderUpsert);
  const canViewAnalytics = checkUserPermissions(accessTitanverseAnalyticsView);

  const tabsConfig = [
    ifPharmacyDashboardEnabled && {
      name: "Dashboard",
      icon: <Heart color={darkMode ? "#fff" : "#6b7280"} size={15} />,
    },

    {
      name: "Services",
      icon: servicesIcon,
    },

    ifWorkForceTabEnabled && {
      name: "Workforce",
      icon: overviewIcon,
    },

    (ifNewCalendar || ifScheduleTabEnabled) && canViewCalendar
      ? {
          name: "Calendar",
          icon: overviewIcon,
        }
      : null,

    ifClinicalChecksEnabled && {
      name: "Clinical Checks",
      icon: overviewIcon,
    },

    ifKanbanSearchBoxEnabled &&
      canViewPatients && {
        name: "Patients",
        icon: <FiUsers color={darkMode ? "#fff" : "#6b7280"} />,
        onClick: handlePatientTabClick,
      },

    ifKanbanSearchBoxEnabled &&
      canViewApprovals && {
        name: "Approvals",
        icon: <FiCheck color={darkMode ? "#fff" : "#6b7280"} />,
        onClick: handleApprovalTabClick,
      },

    ifDocumentsEnabled && {
      name: "Documents",
      icon: <FileText color={darkMode ? "#fff" : "#6b7280"} size={15} />,
      onClick: handleDocumentClick,
    },

    ifPharmacyAnalyticsEnabled &&
      canViewAnalytics && {
        name: "Analytics",
        icon: <BarChart3 color={darkMode ? "#fff" : "#6b7280"} size={18} />,
      },
  ].filter(Boolean);

  const handleTabClick = (event, newIndex) => {
    const tabName = tabsConfig[newIndex]?.name;

    setCurrentGlobalTabValue(newIndex);
    handleGlobalTabsChange(event, newIndex, tabName);
  };
  return (
    <section className="global-tabs-switcher-wrapper">
      <div className="content">
        <div className="left">
          <PharmacyName />
          <div>
            <Tabs value={globalTab} onChange={handleTabClick}>
              {tabsConfig.map((tab, index) => (
                <Tab
                  key={tab.name}
                  disabled={isAppLoading || isTabLoading}
                  icon={tab.icon}
                  iconPosition="start"
                  label={<span className="tabs_text">{tab.name}</span>}
                  onClick={(e) => tab.onClick?.(e)}
                />
              ))}
            </Tabs>
          </div>
        </div>
        <div className="right">
          <div className="team-members-pc">
            {checkUserPermissions(accessTitanversUserUpsert) &&
              headerTeamMembers && <TeamMembers />}
          </div>
        </div>
      </div>
    </section>
  );
}
